export default __webpack_public_path__ + "static/media/DSC_7556.7cbea036.jpg";